import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";

export default async function startBot(username: string, botId: string) {
    let p: OperatorApplicationApi.OperatorMessageStartBotOpenApiModel = {
        username,
        botId
    };
    let result = await (new OperatorApiRequest({
        url: "/message/startBot",
        p
    })).send();

    result.showMessageOnError();
    return result;
}